<p-dialog
  header="{{ confirmDialogContent.head | translate }}"
  [(visible)]="confirmDialogContent.showConfirmDialog"
  [style]="{ width: '34vw' }"
  [modal]="true"
  [closable]="isModal"
  styleClass="{{ confirmDialogContent.styleClass }}"
  [draggable]="false"
>
  <div class="mb-2">
    <p
      class="leading-6"
      [innerHTML]="confirmDialogContent.description | translate"
    ></p>
    <p
      class="leading-6 text-[--pho_white_shade4] mt-[4px]"
      *ngIf="confirmDialogContent?.description_text"
    >
      {{ confirmDialogContent?.description_text | translate }}
    </p>
  </div>
  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-3">
      <app-button-secondary
        (actionButtonCall)="alertBtnAction(false)"
        buttonCaption="{{ confirmDialogContent.btnCancel | translate }}"
        buttonClassName="xs-medium"
      ></app-button-secondary>
      <app-button-primary
        buttonCaption="{{ confirmDialogContent.btnProceed | translate }}"
        (actionButtonCall)="alertBtnAction(true)"
        buttonClassName="xs-medium {{ confirmDialogContent?.btnProceedClass }}"
        [loaderEnabledFlag]="confirmDialogContent?.btnProceedLoading"
      ></app-button-primary>
    </div>
  </ng-template>
</p-dialog>
